export * from './ionic3-star-rating.module';
export * from './components/ionic3-star-rating-component';